export const FETCH_RECOMMANDED_MOVIES = "FETCH_RECOMMANDED_MOVIES";
export const FETCH_POPULAR_MOVIES = "FETCH_POPULAR_MOVIES";
export const FETCH_MOVIE_DETAIL = "FETCH_MOVIE_DETAIL"
export const FETCH_SIMILAR_MOVIES = "FETCH_SIMILAR_MOVIES"
export const GET_SELECTED_MOVIE_ID = "GET_SELECTED_MOVIE_ID"
export const GET_THEATER_AND_SHOW_DETAILS = "GET_THEATER_AND_SHOW_DETAILS"
export const GET_NUMBER_OF_SEATS = "GET_NUMBER_OF_SEATS"
export const GET_PRICE_PER_TICKET = "GET_PRICE_PER_TICKET "
export const GET_SEAT_NUMBERS = "GET_SEAT_NUMBERS"
export const REMOVE_SEAT_NUMBERS = "REMOVE_SEAT_NUMBERS"
export const GET_MOBILE_NUMBER = "GET_MOBILE_NUMBER"
export const GET_EMAIL = "GET_EMAIL"
export const GET_PAYMENT_DETAILS = "GET_PAYMENT_DETAILS"
export const GET_CARD_AND_VALIDATE = "GET_CARD_AND_VALIDATE"
export const GET_NAME_AND_VALIDATE = "GET_NAME_AND_VALIDATE"

